import React from 'react';
import { Form, Upload, Button, Typography, message } from 'antd';
import { UploadOutlined } from '@ant-design/icons';

const { Title } = Typography;

const Step5 = ({ form, next, prev, getValueFromEvent }) => {
  
  // Function to check the file type and restrict it to PDF, JPG, or PNG
  const beforeUpload = (file) => {
    const isAllowedType = file.type === 'application/pdf' || file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isAllowedType) {
      message.error('You can only upload PDF, JPG, or PNG files!');
    }
    return isAllowedType ? true : Upload.LIST_IGNORE;
  };

  return (
    <div>
      <Title level={2}>More about you</Title>
      <Form form={form} layout="vertical" onFinish={next}>
        <Form.Item 
          name="criminalHistoryCheck" 
          label="Please attach a photo of your Criminal History Check." 
          valuePropName="fileList" 
          getValueFromEvent={(info) => {
            if (Array.isArray(info)) {
              return info;
            }
            const { fileList } = info;
            return fileList;
          }} 
          rules={[{ required: true }]}
        >
          <Upload beforeUpload={beforeUpload} listType="picture" maxCount={1}>
            <Button icon={<UploadOutlined />}>Upload</Button>
          </Upload>
        </Form.Item>
        <Form.Item 
          name="taxiDriverAuthority" 
          label="Please attach a photo of any other Taxi Driver Authority if any." 
          valuePropName="fileList" 
          getValueFromEvent={(info) => {
            if (Array.isArray(info)) {
              return info;
            }
            const { fileList } = info;
            return fileList;
          }}
        >
          <Upload beforeUpload={beforeUpload} listType="picture" maxCount={1}>
            <Button icon={<UploadOutlined />}>Upload</Button>
          </Upload>
        </Form.Item>
        <Button style={{ marginRight: 20 }} type="primary" onClick={prev}>Back</Button>
        <Button type="primary" htmlType="submit">Next</Button>
      </Form>
    </div>
  );
};

export default Step5;
